export const PAGE_HEADER_LABELS = {
	TITLE: 'Platform Label Management',
	SUBTITLE: 'Edit core labels or add custom ones to improve filtering in dashboards and reports.',
	CREATE_BUTTON: 'Create Label'
} as const;
